import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@cambridgeassessment/cambridge-ui';
import { Typography } from '@material-ui/core';
import React, { memo } from 'react';
import { hot } from 'react-hot-loader/root';
import { SOCIAL_ICONS } from 'src/constants';
import useAuth from 'src/hooks/useAuth';
import SocialAccountButton from './SocialAccountButton';
import { useStyles } from './styles';

const POSSIBLE_SOCIAL_PROVIDERS = [
  {
    icon: <SOCIAL_ICONS.Facebook />,
    name: 'Facebook',
  },
  {
    icon: <SOCIAL_ICONS.Google />,
    name: 'Google',
  },
  {
    icon: <SOCIAL_ICONS.Apple />,
    name: 'Apple',
  },
  {
    icon: <SOCIAL_ICONS.Microsoft />,
    name: 'Microsoft',
  },
];

const ManageSocialAccounts: React.FC = () => {
  const classes = useStyles();
  const { user } = useAuth();

  return (
    <TableContainer>
      <Table aria-label="social-account-table">
        <TableBody>
          {POSSIBLE_SOCIAL_PROVIDERS.map((row, key) => (
            <TableRow key={key}>
              <TableCell className={classes.tableCellIcon}>
                {row.icon}
              </TableCell>
              <TableCell className={classes.tableCellDetails}>
                <Typography variant="subtitle2">{row.name}</Typography>
                <Typography
                  className={classes.fix}
                  variant="body1"
                  data-testid="isConnected"
                >
                  {(() => {
                    if (
                      user.identities.find(
                        (ele) => ele.provider === row.name.toLowerCase()
                      )
                    ) {
                      return (
                        'Connected - ' +
                        (user.identities.find(
                          (ele) => ele.provider === row.name.toLowerCase()
                        ).email
                          ? user.identities.find(
                              (ele) => ele.provider === row.name.toLowerCase()
                            ).email
                          : 'No email available')
                      );
                    } else {
                      return 'Not connected';
                    }
                  })()}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableCellDetails} align="right">
                <SocialAccountButton
                  key={row.name}
                  title={row.name}
                  isConnected={user.socialProviders.includes(
                    row.name.toLocaleLowerCase()
                  )}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default hot(memo(ManageSocialAccounts));
